import Immutable from 'immutable';
import { normalize } from 'normalizr';
import { 
  FETCH_PROFILE_SUCCESS,
  FETCH_POSTS_REQUEST, FETCH_POSTS_SUCCESS, FETCH_POSTS_ERROR,
  FETCH_COMMENTS_REQUEST, FETCH_COMMENTS_SUCCESS, FETCH_COMMENTS_ERROR, 
  TOGGLE_DIRECTION_AND_EMPTY_ITEMS 
} from '../constants/ActionTypes';
import Comment from '../models/comment';
import Profile from '../models/profile';
import { profile, post, comment } from '../schema';
import humps from 'humps';
import deserialize from '../utils/deserialize';

const initialState = Immutable.Map();

export default function entities(state = initialState, action) {
  switch (action.type) {
    case FETCH_POSTS_SUCCESS:
      {
        const { result } = action;
        const camelized  = humps.camelizeKeys(result);
        const normalizedPosts = deserialize(normalize(action.result.items, [ post ]));
        const entities = normalizedPosts.get('entities');
        return state.mergeDeep(entities);
      }
    case FETCH_PROFILE_SUCCESS:
      {
        const { result } = action;
        const camelized  = humps.camelizeKeys(result);
        camelized.posts.items.forEach(post => {
          post.author = responseProfile.profile;
        });
        const normalizedProfile = deserialize(normalize(camelized, { profile, posts: { items: [ post ] } }));

        const entities = normalizedProfile.get('entities');
        return state.merge(entities);
      }
    case FETCH_COMMENTS_REQUEST:
      {
        return state.update('posts', posts => 
          posts.update(`${action.postId}`,
            post => post.update('comments',
                comments => comments.update('isFetching', isFetching => true)
            )
          )
        );
      }
    case FETCH_COMMENTS_ERROR:
      {
        return state.update('posts', posts => 
          posts.update(`${action.postId}`,
            post => post.update('comments',
              comments => comments.update('isFetching', isFetching => false)
            )
          )
        );
      }
    case FETCH_COMMENTS_SUCCESS:
      {
        const commentsScheme = [ comment ];
        const normalizedComments = normalize(action.result.items, commentsScheme);

        const commentsMap = Immutable.fromJS(normalizedComments.entities.comments).map(comment => new Comment(comment));
        return state.update('comments', comments => commentsMap.concat(comments))
          .update('posts', posts => {
              return posts.update(`${action.postId}`,
                post => post.update('comments',
                  comments => comments.update('hasNext', value => action.result.hasNext)
                    .update('isFetching', isFetching => false)
                    .update('items', items => {
                      return comments.get('direction') && comments.get('direction') === 'forward' ?
                        items.concat(Immutable.fromJS(normalizedComments.result))
                        : Immutable.fromJS(normalizedComments.result).concat(items);
                      }
                    )));
            }
          );
      }
    case TOGGLE_DIRECTION_AND_EMPTY_ITEMS:
      {
        return state.update("posts", posts => {
          return posts.update(`${action.postId}`,
            post => post.update('comments',
              comments => comments.update('direction',
                direction => direction && direction === 'forward' ? 'backward' : 'forward')
                .update('items', items => new Immutable.List())
            ))});
      }
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/reducers/entities.js